function initializeHeroLvl3() {
  // Get hero--lvl-3 element
  const hero = document.querySelector(".hero--lvl-3");
  // Exit if no hero--lvl-3 element is found
  if (!hero) {
    return;
  }

  // Get hero--lvl-3 element's background image
  const heroBackground = hero.querySelector(".hero__background-file");
  // Exit if no hero--lvl-3 element's background image is found
  if (!heroBackground) {
    return;
  }

  function setGradientHeight() {
    // Get the height of the background image
    const heroBackgroundHeight = heroBackground.offsetHeight;

    // Set the css variable --gradient-height to the height of the background image
    hero.style.setProperty("--gradient-height", `${heroBackgroundHeight}px`);
  }

  // Set the gradient height
  setGradientHeight();

  // Set the gradient height on window resize
  window.addEventListener("resize", setGradientHeight);


  /* -------------------------------------------------------------------------- */
  /* Cut off image after it leaves the hero                                     */
  /* -------------------------------------------------------------------------- */

  // Get the height of the hero
  const heroHeight = hero.offsetHeight - 10;
  // Get the height of the background image
  const heroBackgroundHeight = heroBackground.offsetHeight;

  function calculateImageBottomPosition() {
    // Get the current scroll position
    const scrollPosition = window.scrollY;
    // Get the bottom position of the image
    const imageBottomPosition = scrollPosition + heroBackgroundHeight;
    return imageBottomPosition;
  }

  function setImageCutOff() {
    // Get the bottom position of the image
    const imageBottomPosition = calculateImageBottomPosition();
    // Skip if the image is still in the hero
    if (imageBottomPosition < heroHeight) {
      return;
    }
    // Get the cut off value
    const cutOffValueRaw = imageBottomPosition - heroHeight;
    // Set the cut off value to the height of the image if it is bigger than the height of the image
    const cutOffValue = cutOffValueRaw > heroBackgroundHeight ? heroBackgroundHeight : cutOffValueRaw;
    // Set the cut off value
    heroBackground.style.setProperty("--image-cut-off", `${cutOffValue}px`);
  }

  // Set the cut off value
  window.addEventListener("scroll", setImageCutOff);
}

export default initializeHeroLvl3;
